import script from "./WorldMapWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldMapWidget.vue?vue&type=script&setup=true&lang=js"

import "./WorldMapWidget.vue?vue&type=style&index=0&id=bd1d9f24&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1d9f24"]])

export default __exports__